import styled from 'styled-components';

const Wrapper = styled.div`
    font-family: var(--roboto-font);
    min-width: fit-content;
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export default Wrapper;